import { h } from 'preact'
import Icon from '../assets'
import Phrase from '../../libs/translationsUtils/phrase'

interface Props {
  onClick: () => void,
  className?: string
}

const TopicLike = ({ onClick, className }: Props) => {
  return (
    <div className={`post-footer-item text--meta ${className || ''}`} onClick={onClick}>
      <Icon size={16} icon='like' />
      <span className='post-footer-item-text'>
        <Phrase m='Common' p='like' />
      </span>
    </div>
  )
}

export default TopicLike
